export const WRAPPED_WATCHLIST_STORAGE_KEY = "persistedWrappedWatchlist";

export const MARKETS_IS_OPEN_STORAGE_KEY = "isOpenTodayInMarkets";

export const MARKETS_TAB_STORAGE_KEY = "todayInMarketsTab";
